/** @format */
import process from "process";
import { apiRequest } from "../Component/Utils/ApiHundler";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export async function getDocByStatus(token, Status, ModelId = null) {
  const apiUrl = `${API_BASE_URL}/document/list/bystatus`;

  const body = ModelId ? { ModelId: ModelId } : {};

  const data = await apiRequest(apiUrl, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    body: JSON.stringify({
      body,
      Status: Status,
      ModelId: ModelId,
    }),
  });

  return data.message.list;
}